import { createContext } from 'react';

export const UserAdministrationModalContext = createContext(null);

